import React, { useEffect, useState } from "react";
import { clampPercent, easeOutCubic } from "../../utils/clampPercent";

/**
 * Donut pie ring: fill angle = value% of 360° (100 = full circle).
 * Animates quickly from 0 → value when mounted or when value changes.
 */
const ConfidencePieRing = ({
  value,
  size = 132,
  fillColor = "var(--pr-blue-2, #64b5f6)",
  trackColor = "rgba(100, 181, 246, 0.14)",
  holeColor = "#07111f",
  innerRatio = 0.58,
  animate = true,
  duration = 900,
  className = "",
  innerClassName = "confidence-pie-ring-inner",
  children,
}) => {
  const target = clampPercent(value);
  const [display, setDisplay] = useState(animate ? 0 : target);

  useEffect(() => {
    if (!animate) {
      setDisplay(target);
      return undefined;
    }

    let frame;
    const start = performance.now();
    setDisplay(0);

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      setDisplay(Math.round(target * easeOutCubic(t)));
      if (t < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, animate, duration]);

  const fillAngle = display * 3.6;
  const holeStop = `${innerRatio * 100}%`;
  const innerSize = Math.round(size * innerRatio);

  return (
    <div
      className={`confidence-pie-ring ${className}`.trim()}
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle at center, ${holeColor} 0 ${holeStop}, transparent calc(${holeStop} + 1%)), conic-gradient(from -90deg, ${fillColor} 0deg, ${fillColor} ${fillAngle}deg, ${trackColor} ${fillAngle}deg, ${trackColor} 360deg)`,
      }}
    >
      <div className={innerClassName} style={{ width: innerSize, height: innerSize }}>
        {children}
      </div>
    </div>
  );
};

export default ConfidencePieRing;
